import React, { Suspense, useState, useEffect } from 'react';
import { Button, Container, Spinner } from 'reactstrap';
import { useParams } from 'react-router-dom';
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import CONSTANTS from 'utils/CONSTANTS';
import ViewTable from 'utils/ReactTableCards';
import {
  addDoctorCertificate,
  deleteDoctorCertificate,
  editDoctorCertificate,
  getAllDoctorCertificate,
} from 'utils/API/api';
import AddNewModalWithOutButton from 'components/advisor/add-new-Modal-with-out-button';
import IntlMessages from 'helpers/IntlMessages';
import AlertPopup from 'components/alert-popup';

const DoctorCertification = () => {
  const { id: doctorId } = useParams();
  const [doctorCertificateList, setDoctorCertificateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [doctorCertificateData, setDoctorCertificateData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteDoctorAvailability = (doctorAvailabilityId) => {
    setDeleteId(doctorAvailabilityId);
    setIsConfirmationOpen(true);
  };

  const confirmDeleteDoctorAvailability = async () => {
    if (deleteId) {
      const res = await deleteDoctorCertificate(deleteId, doctorId);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setIsConfirmationOpen(false);
      }
    }
  };

  const handleEditDoctorAvailability = (editValue) => {
    if (editValue) {
      setDoctorCertificateData({ ...editValue });
      setEditModalOpen(true);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(false);
      const res = await getAllDoctorCertificate(doctorId);
      if (res !== -1) {
        setDoctorCertificateList(
          res?.data?.data.map((doctorItem, index) => {
            return {
              no: index + 1,
              ...doctorItem,
              name: `${doctorItem?.name}`,

              editData: {
                buttonLabel: 'Edit',
                id: {
                  ...doctorItem,
                  profilePic: '',
                },
                onClick: handleEditDoctorAvailability,
              },
              deleteData: {
                buttonLabel: 'Delete',
                id: doctorItem?.id,
                onClick: handleDeleteDoctorAvailability,
              },
            };
          })
        );
      }
    })();
  }, [refresh]);

  const prepareFormData = (e) => {
    const payload = {};
    CONSTANTS.RIGHT_SIDEBAR_FIELD.DOCTOR_CERTIFICATE_MODAL.forEach((field) => {
      const tempValue = e.target[field.name].value;
      if (tempValue) {
        payload[field.name] = tempValue;
      }
    });

    if (doctorId) {
      payload.doctorId = doctorId;
    }

    return payload;
  };
  const prepareEditFormData = (e) => {
    const payload = {};
    CONSTANTS.RIGHT_SIDEBAR_FIELD.DOCTOR_CERTIFICATE_MODAL.forEach((field) => {
      const tempValue = e.target[field.name].value;
      if (tempValue) {
        payload[field.name] = tempValue;
      }
    });

    if (doctorId) {
      payload.doctorId = doctorId;
    }

    return payload;
  };

  const editDoctorAvailabilityHandler = (e) => {
    e.preventDefault();
    (async () => {
      if (doctorCertificateData?.id) {
        const formData = prepareEditFormData(e);

        setLoading(true);
        const res = await editDoctorCertificate(
          doctorCertificateData?.id,
          doctorId,
          formData
        );
        if (res !== -1) {
          setRefresh((previous) => !previous);
          setEditModalOpen(!editModalOpen);
        }
        setLoading(false);
      }
    })();
  };

  const addDoctorAvailabilityHandler = (e) => {
    e.preventDefault();

    (async () => {
      const formData = prepareFormData(e);

      setLoading(true);
      const res = await addDoctorCertificate(formData);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setModalOpen(!modalOpen);
      }
      setLoading(false);
    })();
  };

  return (
    <Suspense fallback={<div className="loading" />}>
      {!loading ? (
        <>
          <Container
            style={{
              display: 'flex',
              justifyContent: 'end',
              maxWidth: '100%',
              margin: '0px',
              padding: '0',
              marginTop: '-10px',
              marginBottom: '15px',
              marginLeft: '-27px',
            }}
          >
            <Button
              outline
              color="primary"
              className="top-right-button"
              onClick={() => setModalOpen(true)}
            >
              <IntlMessages id={CONSTANTS.TABLE_ID.addDoctorCertificate} />
            </Button>
          </Container>
          <AddNewModalWithOutButton
            sidebarMenu="DOCTOR_CERTIFICATE_MODAL"
            modalTitle={CONSTANTS.TABLE_ID.addDoctorCertificate}
            modalOpen={modalOpen}
            toggleModal={() => setModalOpen(!modalOpen)}
            onSubmit={addDoctorAvailabilityHandler}
            formData={{}}
          />

          <AddNewModalWithOutButton
            sidebarMenu="DOCTOR_CERTIFICATE_MODAL"
            modalTitle={CONSTANTS.TABLE_ID.editDoctorCertificate}
            modalOpen={editModalOpen}
            toggleModal={() => setEditModalOpen(!editModalOpen)}
            onSubmit={editDoctorAvailabilityHandler}
            formData={doctorCertificateData}
          />

          <ViewTable
            headers={CONSTANTS.TABLE_HEADER.DOCTOR_AWARD_LIST}
            items={doctorCertificateList}
            advisorId={CONSTANTS.TABLE_ID.doctorCertificate}
            filterParams="name"
          />

          <AlertPopup
            isOpen={isConfirmationOpen}
            positiveText="Yes"
            negativeText="No"
            warning="Are you sure you want to delete?"
            onNegative={() => {
              setIsConfirmationOpen(false);
              setDeleteId(null);
            }}
            onPositive={confirmDeleteDoctorAvailability}
          />
        </>
      ) : (
        <>
          <Container className="d-flex justify-content-center align-items-center">
            <Spinner
              animation="border"
              className="d-inline-flex m-2 "
              color="$theme-color-yellow-granola"
            />
          </Container>
        </>
      )}
    </Suspense>
  );
};
export default DoctorCertification;
